import React, { useEffect, useState } from "react";
import styles from "./SearchInput.module.css";

/**
 * Debounced search box. Calls onChange(debouncedValue) at most once per `debounce` ms.
 */
export const SearchInput = ({ value = "", onChange, placeholder = "Search...", debounce = 200, autoFocus }) => {
  const [v, setV] = useState(value);

  useEffect(() => { setV(value); }, [value]);

  useEffect(() => {
    const id = setTimeout(() => onChange?.(v), debounce);
    return () => clearTimeout(id);
  }, [v, debounce, onChange]);

  return (
    <div className={styles.wrap}>
      <i className={`bi bi-search ${styles.icon}`} aria-hidden="true" />
      <input
        type="search"
        className={styles.input}
        value={v}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={(e) => setV(e.target.value)}
      />
      {v && (
        <button
          type="button"
          className={styles.clear}
          aria-label="Clear search"
          onClick={() => setV("")}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SearchInput;
